module.exports = __webpack_public_path__ + "img/download-on-app-store-th.cfce1486.svg";